import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Trash2 } from "lucide-react";
import { Section, Field, Choice } from "./formBits";

const Benefits = ({ list, onChange, ro }) => {
  const upd = (i, k, v) => onChange(list.map((b, j) => (j === i ? { ...b, [k]: v } : b)));
  return (
    <div className="sm:col-span-2 space-y-2" data-testid="user-benefits">
      <div className="grid grid-cols-[1fr_90px_90px_90px_32px] gap-2 text-[11px] font-semibold text-slate-500 uppercase">
        <span>Benefit</span><span>Per year</span><span>Used</span><span>Remaining</span><span />
      </div>
      {list.map((b, i) => (
        <div key={i} className="grid grid-cols-[1fr_90px_90px_90px_32px] gap-2 items-center" data-testid={`user-benefit-${i}`}>
          <Input value={b.name} disabled={ro} onChange={(e) => upd(i, "name", e.target.value)} data-testid={`user-benefit-name-${i}`} />
          <Input type="number" step="0.5" value={b.given ?? ""} disabled={ro} onChange={(e) => upd(i, "given", e.target.value)} data-testid={`user-benefit-given-${i}`} />
          <Input type="number" step="0.5" value={b.used ?? ""} disabled={ro} onChange={(e) => upd(i, "used", e.target.value)} data-testid={`user-benefit-used-${i}`} />
          <span className="text-sm font-semibold text-navy" data-testid={`user-benefit-remaining-${i}`}>{(Number(b.given) || 0) - (Number(b.used) || 0)}</span>
          {!ro && <button type="button" onClick={() => onChange(list.filter((_, j) => j !== i))} className="text-slate-400 hover:text-red-600" data-testid={`user-benefit-remove-${i}`}><Trash2 className="w-4 h-4" /></button>}
        </div>
      ))}
      {!ro && <Button type="button" variant="outline" size="sm" onClick={() => onChange([...list, { name: "", given: 0, used: 0 }])} data-testid="user-benefit-add"><Plus className="w-4 h-4 mr-1" />Add benefit</Button>}
    </div>
  );
};

export const HrTab = ({ form, set, ro, groups }) => (
  <div className="space-y-6">
    <Section title="Employment status" testId="user-section-employment">
      <Field label="Title" path="hr.title" form={form} set={set} disabled={ro} />
      <Choice label="Type" path="hr.employment_type" form={form} set={set} disabled={ro} testId="user-employment-type"
        options={[["full_time", "Full time"], ["part_time", "Part time"], ["contractor", "Contractor"]]} />
      <Field label="Start date" path="hr.start_date" type="date" form={form} set={set} disabled={ro} />
      <Field label={`Separation date${form.employment_status === "inactive" ? " *" : ""}`} path="hr.separation_date" type="date" form={form} set={set} disabled={ro} />
    </Section>
    <Section title="Payroll" testId="user-section-payroll">
      <Choice label="Rate type" path="hr.rate_type" form={form} set={set} disabled={ro} testId="user-rate-type"
        options={[["hourly", "Hourly"], ["salary", "Salary"]]} />
      <Field label={form.hr?.rate_type === "salary" ? "Rate amount ($ per year)" : "Rate amount ($ per hour)"} path="hr.rate_amount"
        type="number" step="0.01" form={form} set={set} disabled={ro} />
      <div className="sm:col-span-2">
        <Label className="text-xs">Commission group</Label>
        <Select value={form.hr?.commission_group_id || "none"} disabled={ro} onValueChange={(v) => set("hr.commission_group_id", v === "none" ? "" : v)}>
          <SelectTrigger className="mt-1" data-testid="user-commission-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="none">No commission</SelectItem>
            {groups.map((g) => <SelectItem key={g.id} value={g.id} data-testid={`user-commission-option-${g.id}`}>{g.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <p className="text-xs text-slate-400 mt-1">Groups are managed in Settings → Commission Groups.</p>
      </div>
    </Section>
    <Section title="Benefits" testId="user-section-benefits">
      <Benefits list={form.hr?.benefits || []} onChange={(v) => set("hr.benefits", v)} ro={ro} />
    </Section>
  </div>
);
